(() => {

  const clean = (value, limit = 180) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);

  const reference = (product, variant, sku) => [clean(product), clean(variant), sku ? `SKU ${clean(sku, 80)}` : ''].filter(Boolean).join(' · ');

  const localOrigin = (value) => {

    const path = clean(value, 240);

    try { const parsed = new URL(path, location.origin); return path.startsWith('/') && parsed.origin === location.origin && /^\/(products|collections)\/[^?#\s]+$/.test(parsed.pathname) && (!parsed.search || /^\?variant=\d+$/.test(parsed.search)) ? parsed.pathname + parsed.search : ''; } catch { return ''; }

  };



  if (!customElements.get('performance-product-help')) {

    customElements.define('performance-product-help', class extends HTMLElement {

      connectedCallback() {

        this.updateLinks();

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {

          if (String(data.sectionId) !== this.dataset.sectionId) return;

          this.dataset.sku = data.variant?.sku || '';

          this.dataset.variant = this.dataset.singleVariant === 'true' ? '' : data.variant?.title || '';

          this.dataset.variantId = data.variant?.id || '';

          this.updateLinks();

        });

        this.unsubscribeSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {

          if (!this.closest('product-info')?.contains(data.event?.target)) return;

          // The former variant must not travel with a new or unavailable combination.

          this.dataset.sku = '';

          this.dataset.variant = '';

          this.dataset.variantId = '';

          this.updateLinks();

        });

      }

      disconnectedCallback() {

        this.unsubscribeVariant?.();

        this.unsubscribeSelection?.();

      }

      updateLinks() {

        const origin = localOrigin(this.dataset.productUrl);

        const product = clean(this.dataset.product);

        const variant = clean(this.dataset.variant);

        const sku = clean(this.dataset.sku, 80);

        const selected = this.querySelector('[data-product-reference]');

        if (selected) selected.textContent = reference(product, variant, sku) + (!this.dataset.variantId ? ` · ${this.dataset.choose}` : '');

        this.querySelectorAll('[data-product-contact]').forEach(link => {

          if (this.dataset.directContact === 'true') {
            if (this.dataset.pfpRedirect) { link.href = this.dataset.pfpRedirect; return; }
            const technical = link.dataset.reason === 'tecnica' && this.dataset.technicalEmail !== this.dataset.salesEmail;
            const recipient = technical ? this.dataset.technicalEmail : this.dataset.salesEmail;
            const subject = (technical ? 'Consulta técnica: ' : 'Cotizar ') + product.split(' | ')[0] + ' · ' + this.dataset.contactStore;
            const productUrl = new URL(this.dataset.productUrl, window.location.origin);
            productUrl.search = ''; productUrl.hash = '';
            if (this.dataset.variantId) productUrl.searchParams.set('variant', this.dataset.variantId);
            const message = [(technical ? 'Hola Lauren,' : 'Hola Gus,'), '', technical ? 'Necesito tu ayuda con un proyecto de protección pasiva contra incendio:' : 'Necesito tu ayuda para cotizar este producto:', '', 'Producto: ' + product, 'Presentación y color: ' + (variant || 'por definir'), 'Ficha: ' + productUrl.href, '', technical ? 'Requerimientos y detalles de mi proyecto:' : 'Cantidad y detalles de mi solicitud:'].join('\r\n');
            link.href = 'mailto:' + recipient + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(message);
            return;
          }
          const reason = link.dataset.reason;

          const query = new URLSearchParams({ motivo: reason, producto: product });

          if (variant) query.set('formato', variant);

          if (sku) query.set('sku', sku);

          if (origin) query.set('origen', origin + (this.dataset.variantId ? `?variant=${this.dataset.variantId}` : ''));

          link.href = `${'/pages/contact'}?${query}#ContactForm`;

        });

      }

    });

  }



  const initializeContact = () => {

    const query = new URLSearchParams(window.location.search);

    const aliases = { general: 'consulta', herramienta: 'compra', despacho: 'consulta', cambios: 'posventa', empresa: 'cotizacion' };

    const requestedReason = aliases[query.get('motivo')] || query.get('motivo');

    document.querySelectorAll('[data-performance-contact-context]').forEach(wrapper => {

      if (wrapper.dataset.contextReady === 'true') return;

      wrapper.dataset.contextReady = 'true';

      const select = wrapper.querySelector('[data-performance-reason]');

      if (select && !select.value) {

        const option = Array.from(select.options).find(item => item.dataset.reason === requestedReason);

        if (option) select.value = option.value;

      }

      const product = clean(query.get('producto'));

      const variant = clean(query.get('formato'));

      const sku = clean(query.get('sku'), 80);

      const context = reference(product, variant, sku);

      const field = wrapper.querySelector('[data-performance-reference]');

      if (field && !field.value && context) field.value = context.slice(0, 450);

      const summary = wrapper.querySelector('[data-performance-context-summary]');

      if (summary && context) {

        summary.querySelector('[data-performance-context-text]').textContent = context;

        summary.hidden = false;

      }

      const origin = localOrigin(query.get('origen'));

      const originField = wrapper.querySelector('[data-performance-origin]');

      if (origin && originField) originField.value = origin;

      const guidance = wrapper.querySelector('[data-performance-guidance]');

      const updateGuidance = () => {

        if (!guidance || !select) return;

        const reason = select.selectedOptions[0]?.dataset.reason;

        guidance.textContent = guidance.dataset[['tecnica', 'compra'].includes(reason) ? 'technical' : reason === 'cotizacion' ? 'quote' : ['pedido', 'posventa'].includes(reason) ? 'order' : 'general'];

      };

      select?.addEventListener('change', updateGuidance);

      updateGuidance();

    });

  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeContact);

  else initializeContact();

  document.addEventListener('shopify:section:load', initializeContact);

})();

